var _rect, _g, _rect2, _rect3, _rect4, _rect5, _rect6, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 146,
    viewBox: "0 0 136 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.92476,
    y: 2.92476,
    width: 116.992,
    height: 115.527,
    rx: 20.4733,
    stroke: "#C4C4C4",
    strokeWidth: 5.84952
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3172_23875)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.5078,
    y: 62.8818,
    width: 58.4958,
    height: 58.4946,
    rx: 29.2473,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.726 62.8818C122.901 62.8818 136.004 75.9846 136.004 92.1292C136.004 108.274 122.901 121.376 106.726 121.376C90.5816 121.376 77.5078 108.274 77.5078 92.1292C77.5078 75.9846 90.5816 62.8818 106.726 62.8818ZM106.756 68.7313C103.683 68.7303 100.64 69.3349 97.8004 70.5104C94.9612 71.6859 92.3814 73.4093 90.2085 75.5822C88.0355 77.7551 86.3121 80.3349 85.1365 83.174C83.961 86.0132 83.3564 89.0562 83.3574 92.1292C83.3574 105.056 93.8281 115.527 106.756 115.527C119.683 115.527 130.154 105.056 130.154 92.1292C130.154 79.2018 119.683 68.7313 106.756 68.7313ZM108.218 77.5055V92.8603L121.38 100.669L119.186 104.267L103.831 95.0539V77.5055H108.218Z",
    fill: "#C4C4C4"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.239,
    y: 63.613,
    width: 57.0334,
    height: 57.0322,
    rx: 28.5161,
    stroke: "#C4C4C4",
    strokeWidth: 1.46238
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.77344,
    y: 8.77441,
    width: 105.291,
    height: 105.291,
    stroke: ""
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0967,
    y: 30.7102,
    width: 57.0328,
    height: 13.1614,
    fill: "#C4C4C4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0967,
    y: 52.6458,
    width: 39.4843,
    height: 13.1614,
    fill: "#C4C4C4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 35.0967,
    y: 74.5815,
    width: 21.9357,
    height: 13.1614,
    fill: "#C4C4C4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_3172_23875)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 63.7524,
    cy: 135.999,
    rx: 41.6508,
    ry: 2.55,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.028 135.853C105.029 135.853 105.027 135.855 105.021 135.86C105.025 135.855 105.028 135.853 105.028 135.853ZM104.435 135.892C104.56 135.93 104.664 135.966 104.75 135.999C104.664 136.033 104.56 136.069 104.435 136.106C103.911 136.263 103.117 136.419 102.069 136.571C99.9789 136.874 96.9428 137.148 93.178 137.378C85.6518 137.839 75.2481 138.124 63.7524 138.124C52.2566 138.124 41.853 137.839 34.3268 137.378C30.562 137.148 27.5258 136.874 25.4356 136.571C24.3875 136.419 23.5939 136.263 23.0696 136.106C22.9446 136.069 22.8404 136.033 22.7551 135.999C22.8404 135.966 22.9446 135.93 23.0696 135.892C23.5939 135.736 24.3875 135.579 25.4356 135.427C27.5258 135.125 30.562 134.851 34.3268 134.62C41.853 134.16 52.2566 133.874 63.7524 133.874C75.2481 133.874 85.6518 134.16 93.178 134.62C96.9428 134.851 99.9789 135.125 102.069 135.427C103.117 135.579 103.911 135.736 104.435 135.892ZM22.4764 135.853C22.4768 135.853 22.4797 135.855 22.4839 135.86C22.4781 135.856 22.476 135.853 22.4764 135.853ZM22.4764 136.145C22.476 136.145 22.4781 136.143 22.4839 136.138C22.4797 136.143 22.4768 136.146 22.4764 136.145ZM105.021 136.138C105.027 136.143 105.029 136.145 105.028 136.145C105.028 136.146 105.025 136.143 105.021 136.138Z",
    stroke: "#C4C4C4",
    strokeWidth: 0.850008
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3172_23875",
    x: 15.3015,
    y: 126.649,
    width: 96.9019,
    height: 18.7002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.40003,
    result: "effect1_foregroundBlur_3172_23875"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3172_23875"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 77.5078,
    y: 62.8818,
    width: 58.4958,
    height: 58.4946,
    rx: 29.2473,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.2bcc7b00f394007040fd623e2773e397.svg";
export { ForwardRef as ReactComponent };